export default "__VITE_ASSET__B_LSc4wF__"